export default {
  validate: {
    required: {
      username: "請輸入用戶名",
      password: "請輸入密碼",
      captcha: "請輸入驗證碼",
    },
  },
};
